// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","landing":"App_landing__bdevK","dashboardContainer":"App_dashboardContainer__WOLu9"};